import React, {useEffect,useState} from "react";
import Sidebar from "../../../Components/Sidebar";
import AddMembersForm from "../../../Components/AddMembersForm";
import MembersTable from "../../../Components/MembersTable";
import { useDispatch, useSelector } from "react-redux";
import { fetchCouncilMembers,deleteCouncilMemberById, addCouncilMember, updateCouncilMember } from "../../../redux/actions/aboutUsActions";
import PageComponent from "../../../Components/PageComponent";

function Council() {
  const dispatch = useDispatch();
  const [deletePopup, setDeletePopup] = useState({ isOpen: false, data: null });

  const { data: councilMemberData = [], loading } = useSelector(
    (state) => state.aboutUs.councilMember
  );

  useEffect(() => {
    dispatch(fetchCouncilMembers());
  }, [dispatch]);

  const handleDeleteConfirm = async () => {
    if (deletePopup.data) {
      await dispatch(deleteCouncilMemberById(deletePopup.data.id));
      setDeletePopup({ isOpen: false, data: null });
      dispatch(fetchCouncilMembers());
    }
  };

  const closeDeletePopup = () => {
    setDeletePopup({ isOpen: false, data: null });
  };



  
  return (
    <><PageComponent>
    <div className="flex w-screen h-screen overflow-x-hidden bg-[#F8F7FA]">
      <div className="fixed top-0 left-0 w-64 h-full overflow-y-auto bg-white shadow-md">
        <Sidebar />
      </div>

      <div className="flex-1 p-6 ml-64">
        <div className="flex items-center mb-6 space-x-2 text-3xl text-gray-500">
          <span>About Us</span>
          <span>/</span>
          <span className="text-black">Council</span>
        </div>

        <AddMembersForm title="Add Council Member" addMemberAction={addCouncilMember} fetchMembersAction={fetchCouncilMembers}/>
        <MembersTable
          title="Already added council members"
          editTitle="Edit Council Member"
          MemberData={councilMemberData}
          handleDeleteConfirm={handleDeleteConfirm}
          deletePopup={deletePopup}
          setDeletePopup={setDeletePopup}
          closeDeletePopup={closeDeletePopup}
          loading={loading}
          fetchMembers={fetchCouncilMembers}
          updateMember={updateCouncilMember}
          
        />
      </div>
    </div>
    </PageComponent></>
  );
}


export default Council;
